// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _StrikethroughOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/StrikethroughOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var StrikethroughOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _StrikethroughOutlined.default
    }));
};
/**![strikethrough](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk1MiA0NzRINTY5LjljLTEwLTItMjAuNS00LTMxLjYtNi0xNS45LTIuOS0yMi4yLTQuMS0zMC44LTUuOC01MS4zLTEwLTgyLjItMjAtMTA2LjgtMzQuMi0zNS4xLTIwLjUtNTIuMi00OC4zLTUyLjItODUuMSAwLTM3IDE1LjItNjcuNyA0NC04OSAyOC40LTIxIDY4LjgtMzIuMSAxMTYuOC0zMi4xIDU0LjggMCA5Ny4xIDE0LjQgMTI1LjggNDIuOCAxNC42IDE0LjQgMjUuMyAzMi4xIDMxLjggNTIuNiAxLjMgNC4xIDIuOCAxMCA0LjMgMTcuOC45IDQuOCA1LjIgOC4yIDkuOSA4LjJoNzIuOGM1LjYgMCAxMC4xLTQuNiAxMC4xLTEwLjF2LTFjLS43LTYuOC0xLjMtMTIuMS0yLTE2LTcuMy00My41LTI4LTgxLjctNTkuNy0xMTAuMy00NC40LTQwLjUtMTA5LjctNjEuOC0xODguNy02MS44LTcyLjMgMC0xMzcuNCAxOC4xLTE4My4zIDUwLjktMjUuNiAxOC40LTQ1LjQgNDEuMi01OC42IDY3LjctMTMuNSAyNy4xLTIwLjMgNTguNC0yMC4zIDkyLjkgMCAyOS41IDUuNyA1NC41IDE3LjMgNzYuNSA4LjMgMTUuNyAxOS42IDI5LjUgMzQuMSA0Mkg3MmMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg0MzMuMmMyLjEuNCAzLjkuOCA1LjkgMS4yIDMwLjkgNi4yIDQ5LjUgMTAuNCA2Ni42IDE1LjIgMjMgNi41IDQwLjYgMTMuMyA1NS4yIDIxLjUgMzUuOCAyMC4yIDUzLjMgNDkuMiA1My4zIDg5IDAgMzUuMy0xNS41IDY2LjgtNDMuNiA4OC44LTMwLjUgMjMuOS03NS42IDM2LjQtMTMwLjUgMzYuNC00My43IDAtODAuNy04LjUtMTEwLjItMjUtMjkuMS0xNi4zLTQ5LjEtMzkuOC01OS43LTY5LjUtLjgtMi4yLTEuNy01LjItMi43LTktMS4yLTQuNC01LjMtNy41LTkuNy03LjVoLTc5LjdjLTUuNiAwLTEwLjEgNC42LTEwLjEgMTAuMXYxYy4yIDIuMy40IDQuMi42IDUuNyA2LjUgNDguOCAzMC4zIDg4LjggNzAuNyAxMTguOCA0Ny4xIDM0LjggMTEzLjQgNTMuMiAxOTEuOCA1My4yIDg0LjIgMCAxNTQuOC0xOS44IDIwNC4yLTU3LjMgMjUtMTguOSA0NC4yLTQyLjIgNTcuMS02OSAxMy0yNy4xIDE5LjctNTcuOSAxOS43LTkxLjUgMC0zMS44LTUuOC01OC40LTE3LjgtODEuNC01LjgtMTEuMi0xMy4xLTIxLjUtMjEuOC0zMC44SDk1MmM0LjQgMCA4LTMuNiA4LTh2LTYwYTggOCAwIDAwLTgtNy45eiIgLz48L3N2Zz4=) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(StrikethroughOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'StrikethroughOutlined';
}
var _default = RefIcon;
